export const muiChipTheme = {
  MuiChip: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiChip-label': {
          padding: '4px 8px',
        },
        textTransform: 'uppercase',
        borderRadius: 8,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
        lineHeight: 1.25,
        fontWeight: 700,
        fontFamily: 'RF Rostin',
        '&:not(:last-child)': {
          marginRight: 16,
          [theme.breakpoints.down('sm')]: {
            marginRight: 8,
          },
        },
        '&.MuiChip-colorPrimary': {
          backgroundColor: theme.palette.kit.main,
          color: theme.palette.kit.accent2,
          '& .MuiSvgIcon-root': {
            '&.MuiSvgIcon-colorSecondary': {
              color: theme.palette.kit.accent2,
            },
            '&.MuiSvgIcon-colorPrimary': {
              color: theme.palette.kit.accent2,
            },
          },
        },
        '&.MuiChip-colorSecondary': {
          backgroundColor: theme.palette.kit.accent2,
          color: theme.palette.kit.text.h,
          '& .MuiSvgIcon-root': {
            '&.MuiSvgIcon-colorSecondary': {
              color: theme.palette.kit.text.h,
            },
            '&.MuiSvgIcon-colorPrimary': {
              color: theme.palette.kit.text.h,
            },
          },
        },
        '&.MuiChip-outlined': {
          backgroundColor: 'transparent',
          color: theme.palette.kit.text.h,
          border: '2px solid #4520AB;',
          '& .MuiSvgIcon-root': {
            '&.MuiSvgIcon-colorSecondary': {
              color: theme.palette.kit.text.h,
            },
            '&.MuiSvgIcon-colorPrimary': {
              color: theme.palette.kit.text.h,
            },
          },
        },
      }),
    },
    variants: [
      {
        props: { variant: 'status' },
        style: ({ theme }) => ({
          fontSize: 14,
          padding: '16px 8px',
          [theme.breakpoints.down('sm')]: {
            fontSize: 12,
            padding: '4px 0px',
          },
        }),
      },
      {
        props: { variant: 'orange' },
        style: ({ theme }) => ({
          borderRadius: '20px',
          backgroundColor: theme.palette.kit.infographic.lightOrange,
          color: theme.palette.kit.text.h,
          fontSize: 14,
          padding: '16px 8px',
          [theme.breakpoints.down('sm')]: {
            fontSize: 12,
            padding: '4px 0px',
          },
        }),
      },
    ],
  },
};
